export const SET_FILTERED_ARTICLES = 'SET_FILTERED_ARTICLES'
export const SET_SELECTED_FILTERED_ARTICLES = 'SET_SELECTED_FILTERED_ARTICLES'
export const ADD_SELECTED_FILTERED_ARTICLE = 'ADD_SELECTED_FILTERED_ARTICLE'
export const REMOVE_SELECTED_FILTERED_ARTICLE = 'REMOVE_SELECTED_FILTERED_ARTICLE'
export const RESET_FILTERED_ARTICLES = 'RESET_FILTERED_ARTICLES'
export const SET_FILTERED_ARTICLES_SEARCH_STRING = 'SET_FILTERED_ARTICLES_SEARCH_STRING'
export const SET_LOADING_FILTERED_ARTICLES = 'SET_LOADING_FILTERED_ARTICLES'
export const SET_FILTERED_ARTICLES_PAGE = 'SET_FILTERED_ARTICLES_PAGE'
